module.exports = __webpack_public_path__ + "img/step40_a_remove tray_and_box.f4b7f90e.png";